import { ISOStringFormat } from "date-fns";

export enum Method {
  INSERT = "INSERT",
  UPDATE = "UPDATE"
}

// Array-valued columns (partners.type, partners.partner_contacts,
// manuallyAddedPeople) deliver their before/after sides as arrays
type logFieldValue = string | number | null | string[] | number[];

type fieldDelta = logFieldValue[]; // [previousValue, currentValue]

export enum LogChangeType {
  DEALS = "deals",
  LEADS = "leads",
  COMPANIES = "companies",
  PEOPLE = "people",
  CONTRACTS = "contracts",
  REVENUE_ITEMS = "revenue_items",
  COMMERCIALS = "commercials",
  PARTNERS = "partners",
  PARTNERS_CONTACTS = "partners_contacts"
}

interface LogDelta {
  [fieldName: string]: fieldDelta[];
}

interface LogData {
  id: string;
  entityId: string;
  userId: string;
  timeChange: ISOStringFormat;
  method: Method;
  logDelta: LogDelta | null;
  changeType: LogChangeType;
}

interface SortParams {
  field: string;
  asc: boolean;
}

export type { LogData, LogDelta, SortParams, logFieldValue, fieldDelta };
